import request from './request';
import { getUrlParam, buryMd5Sign, isIOS, toRechargePage } from '../utils/tool';
import { Toast } from 'vant';
import 'vant/es/toast/style';
export const getInfo = () => {
    return request({
        url: '/v1/mstask/activity-reward-status',
        method: 'get',
        params: {
            userID: 1007254,
            activityCategory: 91
        }
    });
};

export const getAward = () => {
    return request({
        url: '/v1/mstask/activity-reward-achieve',
        method: 'post',
        data: {
            activityCategory: 91,
            rewardID: 0,
            action: 4,
            platform: 10
        }
    });
};

export const gamePermission = (permissionCheckScene) => {
    return request({
        url: '/v1/kconf/permission-check',
        method: 'put',
        data: {
            permissionCheckScene,
            userID: getUrlParam('userID') - 0
        }
    });
};

// nacos平台获取配置
export const getNacosConfig = (dataId) => {
    const timeMs = Date.now();
    const data = {
        dataId,
        group: 'skrweb',
        namespaceId: 'namespace_web',
        timeMs,
        apiSecret: 'skr2020'
    };

    const params = {
        url: '/v1/kconf/config',
        method: 'post',
        data: {
            dataId,
            group: 'skrweb',
            namespaceId: 'namespace_web',
            timeMs,
            sign: buryMd5Sign(data)
        }
    };
    return request(params);
};
// 奖励领取/兑换
export const activityAwardGrant = async (
    awardInfo,
    {
        successMsg = '',
        errMsg = '',
        rechargeCallback,
        successCallback,
        isCharege = false,
        isShowLoading,
        errCallback
    }
) => {
    const params = {
        url: '/v1/mstask/activity-award-grant',
        method: 'post',
        data: {
            ...awardInfo,
            platform: isIOS() ? 10 : 20
        }
    };
    try {
        const res = await request(params, isShowLoading);
        if (successMsg) {
            Toast(successMsg);
        }
        successCallback && successCallback();
        return res;
    } catch (err) {
        if (err.errno === 8352222 || err.errno === 8352212 || err.errno === 8352213) {
            if (errMsg) {
                Toast(errMsg);
            } else {
                Toast(err.errmsg);
            }
            if (isCharege) {
                toRechargePage(err.errno, () => {
                    setTimeout(() => {
                        rechargeCallback && rechargeCallback();
                        console.log('rechargeCallback', rechargeCallback);
                    }, 800);
                });
            }
        } else {
            Toast(err.errmsg);
        }
        errCallback && errCallback();
        return null;
    }
};

// 获取活动信息
export const getActivityInfo = async (data, isShowLoading) => {
    const params = {
        url: '/v1/mstask/activity-award-grant-details',
        method: 'get',
        params: {
            ...data,
            platform: isIOS() ? 10 : 20
        }
    };
    try {
        const res = await request(params, isShowLoading);
        return res;
    } catch (err) {
        Toast(err.errmsg);
        return null;
    }
};
// 获取抽奖记录
export const getActivityRecord = async (data, isShowLoading) => {
    const params = {
        url: '/v1/mstask/activity-award-grant-lists',
        method: 'get',
        params: {
            ...data,
            platform: isIOS() ? 10 : 20
        }
    };
    try {
        const res = await request(params, isShowLoading);
        return res;
    } catch (err) {
        Toast(err.errmsg);
        return null;
    }
};

//弹幕信息
export const getBarrageInfo = async (data, isShowLoading) => {
    const params = {
        url: '/v1/mstask/common-marquee-list',
        method: 'get',
        params: {
            ...data,
            platform: isIOS() ? 10 : 20
        }
    };
    try {
        const res = await request(params, isShowLoading);
        return res;
    } catch (err) {
        Toast(err.errmsg);
        return null;
    }
};

//获取概率信息
export const getLotteryList = async ({ lotteryID, limit = 1 }) => {
    const params = {
        url: '/v1/mstask/lottery-base-list',
        method: 'get',
        params: {
            lotteryID,
            limit
        }
    };
    try {
        const res = await request(params);
        return res;
    } catch (error) {
        console.log(error);
        return null;
    }
};

export const exchange = async (exchangeAmount, cb) => {
    try {
        await request({
            url: '/v1/wallet/zz-exchange-by-jz',
            method: 'post',
            data: {
                jzAmount: exchangeAmount,
                platform: isIOS() ? 10 : 20
            }
        });
        Toast('兑换成功');
        cb && cb();
    } catch (err) {
        if ([8302174].includes(err.errno)) {
            Toast('金钻余额不足');
        } else {
            err.errmsg && Toast(err.errmsg);
        }
    }
};

export const exchangeZZ = async (exchangeAmount, costPriceType, cb) => {
    const url =
        costPriceType === 0
            ? '/v1/wallet/zs-exchange-by-zz'
            : costPriceType === 1
            ? '/v1/wallet/zz-exchange-by-jz'
            : '';
    if (!url) return;
    const params = {
        url,
        method: 'post',
        data: {
            platform: isIOS() ? 10 : 20
        }
    };
    if (costPriceType === 0) {
        params.data.zsAmount = exchangeAmount;
    } else {
        params.data.jzAmount = exchangeAmount;
    }
    try {
        await request(params);
        // Toast('兑换成功');
        cb && cb();
    } catch (err) {
        if ([8302174].includes(err.errno)) {
            Toast('钻石余额不足');
        } else {
            err.errmsg && Toast(err.errmsg);
        }
    }
};

export const getZizuanJifenAsset = async () => {
    const params = {
        url: '/v1/mstask/activity-award-grant-details',
        method: 'get',
        params: {
            activityID: 2249,
            platform: isIOS() ? 10 : 20
        }
    };
    try {
        const res = await request(params);
        const { commonValue } = res.data || {};

        let jifenValue = 0;
        commonValue &&
            commonValue.forEach((item) => {
                if (item.checkType === 12) {
                    jifenValue = parseInt(item.value / 1000);
                }
            });
        return jifenValue;
    } catch (err) {
        Toast(err.errmsg);
        return 0;
    }
};

export const getActProjectUpdateVersion = async () => {
    const timeMs = Date.now();
    const data = {
        dataId: 'act-project-version',
        group: 'skrweb',
        namespaceId: 'namespace_web',
        timeMs,
        apiSecret: 'skr2020'
    };

    const params = {
        url: '/v1/kconf/config',
        method: 'post',
        data: {
            dataId: 'act-project-version',
            group: 'skrweb',
            namespaceId: 'namespace_web',
            timeMs,
            sign: buryMd5Sign(data)
        }
    };
    try {
        const res = await request(params, false);
        return res.data?.content || '';
    } catch (err) {
        console.log(err);
        return false;
    }
};

export const getUser = async () => {
    const url = '/v1/users';
    const params = {
        url,
        method: 'get',
        params: {
            userID: Number(getUrlParam('userID'))
        }
    };
    try {
        const res = await request(params);
        return res.data;
    } catch (err) {
        console.log(err);
        return null;
    }
};
